class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.url || this.dataset.loaded === 'true') return;
    this.dataset.loaded = 'true';

    fetch(this.dataset.url)
      .then((response) => {
        if (!response.ok) throw new Error('Unable to load recommendations.');
        return response.text();
      })
      .then((text) => {
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = parsed.querySelector('product-recommendations');
        if (!recommendations || recommendations.innerHTML.trim() === '') return;
        this.innerHTML = recommendations.innerHTML;
        this.hidden = false;
      })
      .catch(() => {
        this.hidden = true;
      });
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}

document.addEventListener('theme:cart:updated', (event) => {
  if (event.detail?.cart?.item_count !== 0) return;
  document.querySelectorAll('[data-cart-recommendations]').forEach((recommendations) => {
    recommendations.hidden = true;
  });
});
